import { connect } from "react-redux";
import merge from "lodash/merge";
import React from "react";

import * as actions from "../actions/actions";
let Loading = require("./loading");

class FortCollectionDetail extends React.Component {
    changeCollectionName(e) {
        let newCollection = merge({}, this.state.collection);
        newCollection.name = e.target.value;

        this.setState({
            collection: newCollection
        });
    }

    changeCollectionIconTags(e) {
        let newCollection = merge({}, this.state.collection);
        newCollection.iconKeys = e.target.value.split(", ");

        this.setState({
            collection: newCollection
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            collection: nextProps.collection
        });
    }

    constructor(props) {
        super(props);

        this.props.fetchFortCollection(this.props.collectionId);

        this.state = {
            collection: undefined
        };
    }

    disableCollection(e) {
        e.preventDefault();

        this.props.disableCollection(this.props.collection);
    }

    featureCollection(e) {
        e.preventDefault();
        if (this.props.collection.featured_collection) {
            this.props.unFeatureCollection(
                "collection",
                this.props.collection.id
            );
        } else {
            this.props.featureCollection(
                "collection",
                this.props.collection.id
            );
        }
    }

    previewCollectionIcons(e) {
        e.preventDefault();

        this.props.previewCollectionIcons(
            this.state.collection.iconKeys,
            this.state.collection.id
        );
    }

    render() {
        if (this.props.collection) {
            let collectionPreview = this.renderCollectionPreview(),
                collectionIconIds = this.renderCollectionIconIds(),
                featureCollectionButton = this.renderFeatureCollectionButton(),
                sponsoredLink,
                sponsorURL,
                sponsorImage;

            if (this.props.collection.sponsor.name) {
                sponsoredLink = (
                    <td>
                        <a
                            href={this.props.collection.sponsor.permalink}
                            title={`Sponsored by ${this.props.collection.name}`}
                        >
                            {this.props.collection.sponsor.name}
                        </a>
                    </td>
                );
            } else {
                sponsoredLink = <td>Not Sponsored</td>;
            }

            if (this.props.collection.sponsor.name) {
                sponsorURL = (
                    <tr>
                        <td>Sponsor URL</td>
                        <td>
                            <a
                                href={`${this.props.collection.sponsor
                                    .permalink}/`}
                            >
                                {this.props.collection.sponsor.permalink}
                            </a>
                        </td>
                    </tr>
                );
                sponsorImage = (
                    <tr>
                        <td>Sponsor Image</td>
                        <td>
                            <img
                                src={`/sponsor_logos/${this.props.collection
                                    .sponsor.permalink}_dark.svg`}
                                alt={this.props.collection.name}
                            />
                        </td>
                    </tr>
                );
            }

            return (
                <div>
                    <div className="container">
                        <form
                            className="admin-form new-form six columns"
                            action={`/fort/collections/${this.props.collection
                                .id}/edit/`}
                        >
                            <ol>
                                <li>
                                    <h3>Modify Collection</h3>
                                </li>
                                <li>
                                    <input
                                        id="collection-name-input"
                                        value={this.state.collection.name}
                                        name={this.state.collection.name}
                                        onChange={this.changeCollectionName.bind(
                                            this
                                        )}
                                    />
                                    <label
                                        htmlFor="collection-name-input"
                                        className="show"
                                    >
                                        Collection Name
                                    </label>
                                </li>
                                <li>
                                    <h3>Add or Remove Icons</h3>
                                </li>
                                <li>
                                    <textarea
                                        id="collection-icons"
                                        name="collection-icons"
                                        placeholder="EX: 12345, 24523, 234623, 234523, 92802"
                                        value={collectionIconIds}
                                        onChange={this.changeCollectionIconTags.bind(
                                            this
                                        )}
                                    />
                                    <label
                                        htmlFor="collection-icons"
                                        className="show"
                                    >
                                        Comma seperated list of icon ID numbers
                                    </label>
                                </li>
                                <li>
                                    <button
                                        id="preview-icons"
                                        className="half button button-process ui_eye"
                                        onClick={this.previewCollectionIcons.bind(
                                            this
                                        )}
                                    >
                                        <span>Preview</span>
                                    </button>
                                    <button
                                        id="save-icons"
                                        type="submit"
                                        className="half button button-process ui_save"
                                        onClick={this.saveCollection.bind(this)}
                                    >
                                        <span>Save</span>
                                    </button>
                                </li>
                                {featureCollectionButton}
                            </ol>
                        </form>

                        <div className="admin-table six columns">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>Name</td>
                                        <td id="collection-name">
                                            <a
                                                href={
                                                    this.props.collection
                                                        .permalink
                                                }
                                            >
                                                {this.props.collection.name}
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Slug</td>
                                        <td id="collecion-slug">
                                            {this.props.collection.slug}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>ID</td>
                                        <td id="collection-id">
                                            {this.props.collection.id}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Published</td>
                                        <td>
                                            {this.props.collection.is_published}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Owner</td>
                                        <td>
                                            <a
                                                href={`${this.props.collection
                                                    .author.permalink}/`}
                                            >
                                                {this.props.collection.author.name}{" "}
                                                (
                                                {
                                                    this.props.collection.author
                                                        .name
                                                }
                                                )
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Icon count</td>
                                        <td>
                                            {this.props.collection.icon_count}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Collaborative Collection</td>
                                        <td>
                                            {
                                                this.props.collection
                                                    .is_collaborative
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Featured</td>
                                        <td>
                                            {
                                                this.props.collection
                                                    .featured_collection
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Sponsor</td>
                                        {sponsoredLink}
                                    </tr>
                                    {sponsorURL}
                                    {sponsorImage}
                                </tbody>
                            </table>
                            {collectionPreview}
                        </div>
                    </div>
                    <div className="container">
                        <form
                            className="kinda-danger-zone"
                            action="./"
                            method="POST"
                            onSubmit={this.disableCollection.bind(this)}
                        >
                            <button
                                className={`button red ui_broken-heart ${this
                                    .props.collection.is_published === "0"
                                    ? "disabled"
                                    : ""}`}
                                type="submit"
                            >
                                <span>
                                    {this.props.collection.is_published === "1"
                                        ? "Disable Collection"
                                        : "Collection is disabled"}
                                </span>
                            </button>

                            <p>
                                Once you push this button, it is very hard to
                                un-do. God speed.
                            </p>
                        </form>
                    </div>
                </div>
            );
        } else {
            return <Loading />;
        }
    }

    renderCollectionPreview() {
        let collectionPreview,
            collectionIcons = [];

        this.props.collection.icons.forEach(icon => {
            collectionIcons.push(
                <li key={icon.id} className="icon-preview" data-id={icon.id}>
                    <a href="#" title={`ID ${icon.id}`} target="_blank">
                        <img
                            src={icon.preview_url_84}
                            alt={icon.term}
                            width="42"
                            height="42"
                        />
                    </a>
                </li>
            );
        });

        collectionPreview = (
            <ol id="collection-preview" className="collection-preview">
                {collectionIcons}
            </ol>
        );

        return collectionPreview;
    }

    renderCollectionIconIds() {
        let collectionIconIds,
            newCollection = merge({}, this.state.collection);

        return newCollection.iconKeys
            .map(function(iconId) {
                return iconId;
            })
            .join(", ");
    }

    renderFeatureCollectionButton() {
        let featureCollectionButton;

        if (this.props.collection.is_published === "1") {
            featureCollectionButton = (
                <li>
                    <button
                        id="feature_collection"
                        className={`
                        button
                        ${this.props.collection.featured_collection
                            ? "gray"
                            : "yellow"}
                        full-width
                    `}
                        onClick={this.featureCollection.bind(this)}
                    >
                        <span>
                            {this.props.collection.featured_collection
                                ? "Unfeature Collection"
                                : "Feature Collection"}
                        </span>
                    </button>
                </li>
            );
        }

        return featureCollectionButton;
    }

    saveCollection(e) {
        e.preventDefault();

        this.props.saveCollection(this.state.collection);

        window.location.reload(); // hack to reload since I don't have to have to pass an action for save collection
    }
}

function mapStateToProps(state, ownProps) {
    let collection;

    if (state.collections.keys) {
        state.collections.keys.forEach(collectionId => {
            if (collectionId === ownProps.collectionId) {
                collection = merge({}, state.collections[collectionId]);
                let icons = collection.icons;
                collection.icons = [];
                if (collection.iconKeys) {
                    collection.iconKeys.forEach(iconId => {
                        collection.icons.push(icons[iconId]);
                    });
                } else {
                    collection.iconKeys = [];
                }
            }
        });
    }

    return { collection };
}

module.exports = connect(mapStateToProps, {
    disableCollection: actions.disableCollection,
    featureCollection: actions.featureCollection,
    unFeatureCollection: actions.unFeatureCollection,
    fetchFortCollection: actions.fetchFortCollection,
    previewCollectionIcons: actions.previewCollectionIcons,
    saveCollection: actions.saveCollection
})(FortCollectionDetail);
